"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonType = exports.ButtonSizeTypes = exports.ButtonThemeTypes = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var SyncSpinner_1 = __importStar(require("../Icons/SyncSpinner/SyncSpinner"));
var Link_1 = __importDefault(require("../Link/Link"));
var b2c_theme_1 = require("../Theme/b2c-theme");
var ButtonThemeTypes;
(function (ButtonThemeTypes) {
    ButtonThemeTypes["danger"] = "danger";
    ButtonThemeTypes["grey"] = "grey";
    ButtonThemeTypes["primary"] = "primary";
    ButtonThemeTypes["secondary"] = "secondary";
    ButtonThemeTypes["success"] = "success";
    ButtonThemeTypes["transparent"] = "transparent";
    ButtonThemeTypes["white"] = "white";
    ButtonThemeTypes["paypalBlue"] = "paypalBlue";
    ButtonThemeTypes["mighty"] = "mighty";
    ButtonThemeTypes["ghost"] = "ghost";
    ButtonThemeTypes["ghostWhite"] = "ghostWhite";
    ButtonThemeTypes["lime"] = "lime";
})(ButtonThemeTypes = exports.ButtonThemeTypes || (exports.ButtonThemeTypes = {}));
var ButtonSizeTypes;
(function (ButtonSizeTypes) {
    ButtonSizeTypes["small"] = "small";
    ButtonSizeTypes["medium"] = "medium";
    ButtonSizeTypes["default"] = "default";
    ButtonSizeTypes["large"] = "large";
})(ButtonSizeTypes = exports.ButtonSizeTypes || (exports.ButtonSizeTypes = {}));
var ButtonType;
(function (ButtonType) {
    ButtonType["button"] = "button";
    ButtonType["reset"] = "reset";
    ButtonType["submit"] = "submit";
})(ButtonType = exports.ButtonType || (exports.ButtonType = {}));
var buttonThemePicker = function (theme) {
    switch (theme) {
        case ButtonThemeTypes.danger:
            return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        background-color: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "], ["\n        background-color: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "])), b2c_theme_1.colors.button.danger, b2c_theme_1.colors.button.danger, b2c_theme_1.colors.button.font.light, b2c_theme_1.colors.button.primary);
        case ButtonThemeTypes.secondary:
            return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        background-color: ", ";\n        /* Deliberately thicker as background is dark */\n        border: 3px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "], ["\n        background-color: ", ";\n        /* Deliberately thicker as background is dark */\n        border: 3px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "])), b2c_theme_1.colors.button.secondary, b2c_theme_1.colors.button.secondary, b2c_theme_1.colors.button.font.light, b2c_theme_1.colors.button.outline.default);
        case ButtonThemeTypes.success:
            return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        background-color: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "], ["\n        background-color: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "])), b2c_theme_1.colors.button.success, b2c_theme_1.colors.button.success, b2c_theme_1.colors.button.font.light, b2c_theme_1.colors.button.outline.dark);
        case ButtonThemeTypes.transparent:
            return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        background-color: transparent;\n        border: 1px solid transparent;\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "], ["\n        background-color: transparent;\n        border: 1px solid transparent;\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "])), b2c_theme_1.colors.button.font.dark, b2c_theme_1.colors.button.outline.default);
        case ButtonThemeTypes.grey:
            return (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        background-color: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "], ["\n        background-color: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "])), b2c_theme_1.colors.button.grey, b2c_theme_1.colors.button.grey, b2c_theme_1.colors.button.font.dark, b2c_theme_1.colors.button.outline.default);
        case ButtonThemeTypes.white:
            return (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        background-color: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "], ["\n        background-color: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "])), b2c_theme_1.colors.button.white, b2c_theme_1.colors.button.white, b2c_theme_1.colors.button.font.dark, b2c_theme_1.colors.button.outline.default);
        case ButtonThemeTypes.paypalBlue:
            return (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n        background-color: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "], ["\n        background-color: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "])), b2c_theme_1.colors.button.paypalBlue, b2c_theme_1.colors.button.paypalBlue, b2c_theme_1.colors.button.font.white, b2c_theme_1.colors.button.outline.default);
        case ButtonThemeTypes.mighty:
            return (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n        background-color: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "], ["\n        background-color: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "])), b2c_theme_1.brandColors.mighty, b2c_theme_1.brandColors.mighty, b2c_theme_1.colors.button.font.white, b2c_theme_1.colors.button.outline.default);
        case ButtonThemeTypes.ghost:
            return (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n        background-color: transparent;\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "], ["\n        background-color: transparent;\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "])), b2c_theme_1.colors.button.ghostButtonBorder, b2c_theme_1.colors.button.font.dark, b2c_theme_1.colors.button.outline.default);
        case ButtonThemeTypes.ghostWhite:
            return (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n        background-color: transparent;\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "], ["\n        background-color: transparent;\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "])), b2c_theme_1.colors.button.ghostWhiteButtonBorder, b2c_theme_1.colors.button.font.white, b2c_theme_1.colors.button.outline.default);
        case ButtonThemeTypes.lime:
            return (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n        background-color: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "], ["\n        background-color: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "])), b2c_theme_1.colors.button.lime, b2c_theme_1.colors.button.lime, b2c_theme_1.colors.button.font.dark, b2c_theme_1.colors.button.outline.default);
        default:
            return (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n        background-color: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "], ["\n        background-color: ", ";\n        border: 1px solid ", ";\n        color: ", ";\n\n        &:focus {\n          border-color: ", ";\n        }\n      "])), b2c_theme_1.colors.button.primary, b2c_theme_1.colors.button.primary, b2c_theme_1.colors.button.font.default, b2c_theme_1.colors.primaryLightFontColor);
    }
};
var buttonSizePicker = function (size) {
    switch (size) {
        case ButtonSizeTypes.small:
            return "\n        font-family: ".concat(b2c_theme_1.fonts.defaultMedium, ";\n        font-size: 1.2rem;\n        line-height: 2rem;\n        text-align: center;\n        padding: 0.4rem 1rem;\n      ");
        case ButtonSizeTypes.medium:
            return "\n        font-family: ".concat(b2c_theme_1.fonts.defaultMedium, ";\n        font-size: 1.4rem;\n        line-height: 2.2rem;\n        text-align: center;\n        padding: 1.3rem 2rem;\n      ");
        case ButtonSizeTypes.large:
            return "\n        font-family: ".concat(b2c_theme_1.fonts.defaultMedium, ";\n        font-size: 1.6rem;\n        line-height: 2rem;\n        text-align: center;\n        padding: 2.9rem 4rem;\n      ");
        default:
            return "\n        font-family: ".concat(b2c_theme_1.fonts.defaultMedium, ";\n        font-size: 1.6rem;\n        line-height: 2rem;\n        text-align: center;\n        padding: 1.9rem 3rem;\n      ");
    }
};
var ButtonElement = styled_components_1.default.button(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  border-radius: ", ";\n  cursor: ", ";\n  opacity: ", ";\n  ", "\n\n  &:hover {\n    transition: opacity 0.3s ease-in-out;\n    opacity: 0.8;\n  }\n\n  &:focus {\n    outline: none;\n    text-decoration: underline;\n  }\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  border-radius: ", ";\n  cursor: ", ";\n  opacity: ", ";\n  ", "\n\n  &:hover {\n    transition: opacity 0.3s ease-in-out;\n    opacity: 0.8;\n  }\n\n  &:focus {\n    outline: none;\n    text-decoration: underline;\n  }\n"])), function (_a) {
    var caps = _a.caps;
    return (caps && 'text-transform: uppercase;') || '';
}, function (_a) {
    var block = _a.block;
    return (block && 'display: block; width: 100%;') || '';
}, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return buttonThemePicker(disabled ? ButtonThemeTypes.grey : theme);
}, function (_a) {
    var size = _a.size;
    return buttonSizePicker(size);
}, function (_a) {
    var notRounded = _a.notRounded;
    return (notRounded ? '0' : '60px');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 0.8 : 1);
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled &&
        "\n    border: 1px solid ".concat(b2c_theme_1.colors.button.disabledButtonBorder, ";\n    color: ").concat(b2c_theme_1.palette.greyDisabledT, ";\n    ")) ||
        '';
});
var ButtonLinkElement = (0, styled_components_1.default)(Link_1.default)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  border-radius: ", ";\n  cursor: ", ";\n  text-decoration: none;\n  opacity: ", ";\n  ", "\n\n  & > span {\n    ", "\n    ", "\n    ", "\n  }\n\n  &:hover {\n    transition: opacity 0.3s ease-in-out;\n    opacity: 0.8;\n    text-decoration: none;\n  }\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  border-radius: ", ";\n  cursor: ", ";\n  text-decoration: none;\n  opacity: ", ";\n  ", "\n\n  & > span {\n    ", "\n    ", "\n    ", "\n  }\n\n  &:hover {\n    transition: opacity 0.3s ease-in-out;\n    opacity: 0.8;\n    text-decoration: none;\n  }\n"])), function (_a) {
    var caps = _a.caps;
    return (caps && 'text-transform: uppercase;') || '';
}, function (_a) {
    var block = _a.block;
    return (block && 'display: block; width: 100%;') || '';
}, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return buttonThemePicker(disabled ? ButtonThemeTypes.grey : theme);
}, function (_a) {
    var size = _a.size;
    return buttonSizePicker(size);
}, function (_a) {
    var notRounded = _a.notRounded;
    return (notRounded ? '0' : '60px');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 0.8 : 1);
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled && "border: 1px solid ".concat(b2c_theme_1.colors.button.disabledButtonBorder, ";")) ||
        '';
}, function (_a) {
    var caps = _a.caps;
    return (caps && 'text-transform: uppercase;') || '';
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    if (disabled) {
        return buttonThemePicker(ButtonThemeTypes.grey);
    }
    if (theme === ButtonThemeTypes.ghost) {
        return "\n          border: none;\n        ";
    }
    if (theme === ButtonThemeTypes.ghostWhite) {
        return "\n        border: none;\n        color: ".concat(b2c_theme_1.colors.button.font.white, ";\n      ");
    }
    return buttonThemePicker(theme);
}, function (_a) {
    var size = _a.size;
    return buttonSizePicker(size);
});
var Spinner = styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  user-select: none;\n  pointer-events: none;\n  position: absolute;\n  display: ", ";\n  top: calc(50% - 12px);\n  left: calc(50% - 12px);\n"], ["\n  user-select: none;\n  pointer-events: none;\n  position: absolute;\n  display: ", ";\n  top: calc(50% - 12px);\n  left: calc(50% - 12px);\n"])), function (_a) {
    var isLoading = _a.isLoading;
    return (isLoading ? 'block' : 'none');
});
var ButtonContainer = styled_components_1.default.span(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  display: ", ";\n  position: relative;\n"], ["\n  display: ", ";\n  position: relative;\n"])), function (_a) {
    var block = _a.block;
    return (block ? 'block' : 'inline');
});
var ButtonTextWrapper = styled_components_1.default.span(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  opacity: ", ";\n  display: flex;\n  justify-content: ", ";\n  align-items: center;\n  font-weight: 400;\n"], ["\n  opacity: ", ";\n  display: flex;\n  justify-content: ", ";\n  align-items: center;\n  font-weight: 400;\n"])), function (_a) {
    var isLoading = _a.isLoading;
    return (isLoading ? '0' : '1');
}, function (_a) {
    var textAlign = _a.textAlign;
    switch (textAlign) {
        case 'left':
            return 'flex-start';
        case 'right':
            return 'flex-end';
        case 'justify':
            return 'space-between';
        default:
            return 'center';
    }
});
var IconContainer = styled_components_1.default.i(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  margin: ", ";\n  line-height: 1;\n"], ["\n  margin: ", ";\n  line-height: 1;\n"])), function (_a) {
    var isPre = _a.isPre;
    return (isPre ? '0 1rem 0 0.3rem' : '0 0.3rem 0 1rem');
});
var Button = function (props) {
    var defaultProps = {
        assistiveLoadingText: 'Loading',
        block: false,
        caps: false,
        disabled: false,
        isLoading: false,
        notRounded: false,
        targetBlank: false,
        size: ButtonSizeTypes.default,
        textAlign: 'center',
        theme: ButtonThemeTypes.primary,
        type: ButtonType.submit,
    };
    var _a = __assign(__assign({}, defaultProps), props), assistiveLoadingText = _a.assistiveLoadingText, block = _a.block, caps = _a.caps, children = _a.children, disabled = _a.disabled, href = _a.href, isLoading = _a.isLoading, notRounded = _a.notRounded, onClick = _a.onClick, preIcon = _a.preIcon, postIcon = _a.postIcon, targetBlank = _a.targetBlank, textAlign = _a.textAlign, rel = _a.rel, size = _a.size, theme = _a.theme, type = _a.type, rest = __rest(_a, ["assistiveLoadingText", "block", "caps", "children", "disabled", "href", "isLoading", "notRounded", "onClick", "preIcon", "postIcon", "targetBlank", "textAlign", "rel", "size", "theme", "type"]);
    var _b = (0, react_1.useState)(b2c_theme_1.IconSizes.default), iconSize = _b[0], setIconSize = _b[1];
    var _c = (0, react_1.useState)(SyncSpinner_1.IconColorThemes.default), iconColor = _c[0], setIconColor = _c[1];
    (0, react_1.useEffect)(function () {
        switch (size) {
            case ButtonSizeTypes.small:
                setIconSize(b2c_theme_1.IconSizes.xSmall);
            case ButtonSizeTypes.medium:
                setIconSize(b2c_theme_1.IconSizes.small);
                return;
            case ButtonSizeTypes.large:
                setIconSize(b2c_theme_1.IconSizes.medium);
                return;
            default:
                setIconSize(b2c_theme_1.IconSizes.default);
        }
    }, [size]);
    (0, react_1.useEffect)(function () {
        switch (theme) {
            case ButtonThemeTypes.danger:
            case ButtonThemeTypes.secondary:
            case ButtonThemeTypes.success:
            case ButtonThemeTypes.paypalBlue:
            case ButtonThemeTypes.mighty:
                setIconColor(SyncSpinner_1.IconColorThemes.white);
                return;
            default:
                setIconColor(SyncSpinner_1.IconColorThemes.default);
        }
    });
    var onClickProxy = onClick
        ? function (event) {
            if (!disabled) {
                onClick(event);
            }
        }
        : undefined;
    if (href) {
        return (react_1.default.createElement(ButtonLinkElement, { block: block, caps: caps, "data-testid": "button-element-link", disabled: disabled, href: href, iconColor: iconColor, notRounded: notRounded, onClick: onClick, postIcon: postIcon, preIcon: preIcon, rel: targetBlank ? rel || 'noopener noreferrer' : rel, size: size, target: targetBlank ? '_blank' : undefined, text: children, theme: theme }));
    }
    return (react_1.default.createElement(ButtonContainer, { block: block, "aria-busy": isLoading },
        react_1.default.createElement(ButtonElement, __assign({ block: block, caps: caps, "data-testid": "button-element", disabled: disabled, notRounded: notRounded, onClick: onClickProxy, size: size, theme: theme, type: type }, rest),
            react_1.default.createElement(ButtonTextWrapper, { "aria-hidden": isLoading, "data-testid": "button-element-text", isLoading: isLoading, textAlign: textAlign },
                !isLoading && preIcon && react_1.default.isValidElement(preIcon) ? (react_1.default.createElement(IconContainer, { isPre: true, "aria-hidden": "true", "data-testid": "button-pre-icon-container" }, react_1.default.cloneElement(preIcon, {
                    focusable: 'false',
                    color: iconColor,
                    size: iconSize,
                    'data-testid': 'button-pre-icon',
                }))) : null,
                children,
                !isLoading &&
                    !preIcon &&
                    postIcon &&
                    react_1.default.isValidElement(postIcon) ? (react_1.default.createElement(IconContainer, { "aria-hidden": "true", "data-testid": "button-post-icon-container" }, react_1.default.cloneElement(postIcon, {
                    focusable: 'false',
                    color: iconColor,
                    size: iconSize,
                    'data-testid': 'button-post-icon',
                }))) : null)),
        react_1.default.createElement(Spinner, { "data-testid": "button-element-spinner", isLoading: isLoading, role: "alert", "aria-hidden": !isLoading, "aria-label": assistiveLoadingText },
            react_1.default.createElement(SyncSpinner_1.default, { color: iconColor, size: b2c_theme_1.IconSizes.medium }))));
};
exports.default = Button;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;
//# sourceMappingURL=Button.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/b-apps_b2c-site_b2c-site_develop/node_modules/@urbanmassage/component-library/lib/Button/Button.js
// module id = 143
// module chunks = 81